const fetchExamsCount = async (_bundleId: string) => {
	return {
		numPracticeTests: 0,
		numQuiz: 0,
		exams: [],
	};
};

export default fetchExamsCount;
